import { CategoryOpenMode } from '../../../models/category/category';
import { MenuItemViewModelType } from '../../../services/menu/MenuItemViewModel';
import MenuService from '../../../services/menu/MenuService';
import { getFilteredMenuItems, getMenuItem } from '../../selectors/menu';
import category from '../../slices/category';
import menu from '../../slices/menu';
import { apiCall, createAppListener, postDispatch } from '../listenerHelpers';

const menuListener = createAppListener();

const menuService = new MenuService();

menuListener.startListening(
  apiCall(
    {
      request: menu.get,
      success: menu.getSuccess,
      failure: menu.getFailure,
    },
    async ({ application }) => {
      const menuModel = await menuService.getMenu(application);
      return { menu: menuModel };
    }
  )
);

menuListener.startListening(
  postDispatch(menu.submitSearch, (_payload, state, dispatch) => {
    const filteredItems = getFilteredMenuItems(state);

    if (filteredItems.length === 0) {
      return;
    }

    const firstItem = getMenuItem(state, filteredItems[0]);

    if (firstItem.type === MenuItemViewModelType.DISPLAY_MODE) {
      dispatch(menu.toggleOpened());
      dispatch(
        category.openDisplayMode({
          category: firstItem.category,
          displayMode: firstItem.displayMode,
          ui: { mode: CategoryOpenMode.CONTENT },
          inParams: firstItem.inParams,
        })
      );
    }
  })
);

export default menuListener.middleware;
